/**
 * A trailing block is droppable when it has no children, or all its children
 * are whitespace-only text nodes or hard breaks. Interior blank lines are kept
 * (only the trailing run is trimmed) so intentional spacing survives.
 */
function isBlankBlock(node: { type?: string; content?: unknown[] }): boolean {
  if (node.type !== 'paragraph') return false;
  const children = node.content;
  if (!Array.isArray(children) || children.length === 0) return true;
  return children.every((child) => {
    const c = child as { type?: string; text?: string };
    if (c.type === 'hardBreak') return true;
    if (c.type === 'text') return (c.text ?? '').trim() === '';
    return false;
  });
}

export function trimTrailingBlocks(
  content: Array<{ type?: string; content?: unknown[] }>,
): Array<{ type?: string; content?: unknown[] }> {
  const nodes = [...content];
  while (nodes.length > 0) {
    const last = nodes[nodes.length - 1];
    if (isBlankBlock(last)) {
      nodes.pop();
      continue;
    }
    // Otherwise non-blank: strip a trailing hard break inside the last
    // paragraph (Cmd+Enter inserts a HardBreak at the ProseMirror layer before
    // submit, leaving "text\n" → keep "text").
    if (last.type === 'paragraph' && Array.isArray(last.content) && last.content.length > 0) {
      const inner = last.content as Array<{ type?: string }>;
      if (inner[inner.length - 1]?.type === 'hardBreak') {
        nodes[nodes.length - 1] = { ...last, content: inner.slice(0, -1) };
        continue;
      }
    }
    break;
  }
  return nodes;
}
